define("media/models/ig-reel", ["exports", "@ember/object"], function (_exports, _object) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _default = _object.default.extend({
    caption: null,
    createdTime: null,
    exits: null,
    id: null,
    imageUrl: null,
    mediaUrl: null,
    commentCount: null,
    likeCount: null,
    savedCount: null,
    reach: null,
    videoViews: null,
    shareCount: null,
    thumbnailUrl: null,
    timeCollected: null,
    imageMediumUrl: null,
    instagramLink: null,
    mediaProductType: null
  });

  _exports.default = _default;
});